import { render, staticRenderFns } from "./ContestActivityComponent.vue?vue&type=template&id=37a73f75"
import script from "./ContestActivityComponent.vue?vue&type=script&lang=js"
export * from "./ContestActivityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports